import { getRequest, postJSONRequest } from '../../utils/requests';
import { handleAPIError } from '../../utils/apiResponeHandler';
import { gt_config } from '../../configs';
import { localTrim, retProperVal } from '../../utils/strings';

export const gtPostActivity = async (message, postPayload = null) => {
  if (retProperVal(message) === null) return false;
  try {
    let toPost = {};
    if (postPayload != null)
      toPost = {
        payload: postPayload,
        message: localTrim(message),
      };
    else
      toPost = {
        message: localTrim(message),
      };

    const response = await fetch(
      postJSONRequest(`${gt_config.urls.activityfeed}gtpost`, toPost),
    );
    const res = await handleAPIError(response);
    const json = await res.json();

    if (json.status === true) {
      return json;
    }
  } catch (error) {
    // do nothing
    console.error(error);
  }
  return false;
};

export const fetchInitial = async () => {
  try {
    const response = await fetch(
      getRequest(`${gt_config.urls.activityfeed}user/post`),
    );
    const res = await handleAPIError(response);
    const json = await res.json();
    if (json.status === true) {
      return json.data;
    }
  } catch (error) {
    // do nothing
    console.error(error);
    return error;
  }
  return [];
};

export const fetchSubsequent = async (lastId) => {
  try {
    const response = await fetch(
      getRequest(`${gt_config.urls.activityfeed}user/post?last_id=${lastId}`),
    );
    const res = await handleAPIError(response);
    const json = await res.json();
    if (json.status === true) {
      return json.data;
    }
  } catch (error) {
    // do nothing
    console.error(error);
    return error;
  }
  return [];
};
